import { render, staticRenderFns } from "./WiseAccountPreview.vue?vue&type=template&id=43631ea0&"
import script from "./WiseAccountPreview.vue?vue&type=script&lang=js&"
export * from "./WiseAccountPreview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports